// extracted by mini-css-extract-plugin
export default {"DeleteButton":"CostumerListTable_DeleteButton__ArF21","EditButton":"CostumerListTable_EditButton__NRZV1"};